import {
  Dimensions,
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { getLoginData } from "../../../utility/AppStoreData";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import InviteOpponentModal from "./InviteOpponentModal";
import SearchFromFriendsModal from "./SearchFromFriendsModal";
import InviteSocialMediaModal from "./InviteSocialMediaModal";
import dayjs from "dayjs";
import { s } from "react-native-size-matters";
import { ShowLoader } from "../../../common/ShowLoader";
import { base_url, endpoints } from "../../../Api/configs";
import ChallengeSentSuccessfulyModal from "./ChallengeSentSuccessfulyModal";
import { createEvent } from "../../../services/eventsAPI";
import { handleApiError } from "../../../services/errorHandler";
import { uploadToS3 } from "../../../services/authAPI";
import { AppImages } from "../../../utility/AppImages";
import { AppScreens } from "../../Utility/AppScreens";
import { fetchUserConnectionStatus } from "../../../services/stream";
import { toast } from "react-toastify";
import TicketDetail from "../../../Components/create-event-components/TicketDetail";
import { CropImage } from "../../../Components/choose-avatar-components/CropImage";
import Header from "../WebScreens/Common/Header";
import { ScreenBGGradientView } from "../../../common/CommonView";

export default function PrivateEventSummary({ navigation }) {
  const [userData, setUserData] = useState(null);
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [platformStatus, setPlatformStatus] = useState({
    YouTube: "Not connected",
    Twitch: "Not connected",
  });

  const [inviteOpponentModal, setInviteOpponentModal] = useState(false);
  const [eventID, setEventId] = useState("123456");
  const [accessToken, setAccessToken] = useState("");
  const [searchFromFriendsModal, setSearchFromFriendsModal] = useState(false);
  const [inviteSocialMediaModal, setInviteSocialMediaModal] = useState(false);
  const [eventData, setEventData] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const [showCreateLoader, setCreateShowLoader] = useState(false);
  const [eventDetails, setEventDetails] = useState(null);
  const [gameName, setGameName] = useState("");
  const [challengeDetails, setChallengeDetails] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [eventPicUrl, setEventPicUrl] = useState("");
  const screenWidth = Dimensions.get("window").width;
  const fetchStatus = async () => {
    try {
      const response = await fetchUserConnectionStatus(accessToken);
      if (response.statusCode === 200) {
        setPlatformStatus(response.body);
      } else {
        toast.error("Failed to fetch platform connection status.");
      }
    } catch (error) {
      console.error("Error fetching platform status:", error);
      toast.error("Failed to fetch platform connection status.");
    }
  };
  const [isChecked, setIsChecked] = useState(false);
  const toggleCheckbox = () => {
    setIsChecked(!isChecked);
  };
  const savedEventData = JSON.parse(localStorage.getItem("createEventData"));
  const eventType = savedEventData?.eventType;
  useEffect(() => {
    getLoginUserData();
    // setEventId("");

    if (savedEventData && Object.keys(savedEventData).length > 0) {
      // eventData exists and is not empty
      setEventData(savedEventData);
      let partData = {
        eventType: savedEventData?.eventType,
        title: savedEventData?.title,
        description: savedEventData?.description,
        startDateTime: savedEventData?.startDateTime,
        organiserId: savedEventData?.organiserId,
        gameTitle: savedEventData?.gameTitle,
        stakeType: savedEventData?.stakeType,
        stakeAmount: savedEventData?.stakeAmount,
        gamerID: {
          organiser: savedEventData?.gamerId.organiser,
          challenger: "",
        },
        device: savedEventData?.device,
        allOrNothing: savedEventData?.allOrNothingSwitch,
        publicVotingEnabled: savedEventData?.publicVotingEnabled,
      };
      if (savedEventData?.eventType === "Private") {
        //@ts-ignore
        partData.minimumAttendees = savedEventData?.minimumAttendees;
      }
      if (savedEventData?.eventType === "Private") {
        //@ts-ignore
        partData.determineTheStakesValue =
          savedEventData?.determineTheStakesValue;
      }
      if (savedEventData?.eventType === "Private") {
        //@ts-ignore
        partData.ticketPriceCurrency = savedEventData?.ticketPriceCurrency;
      }
      if (savedEventData?.eventType === "Private") {
        //@ts-ignore
        partData.organiserPercentage = savedEventData?.organiserPercentage;
      }
      if (savedEventData?.eventType === "Private") {
        //@ts-ignore
        partData.challengerPercentage = savedEventData?.challengerPercentage;
      }
      if (savedEventData?.eventType === "Private") {
        //@ts-ignore
        partData.anticipatedCost = savedEventData?.anticipatedCost;
      }

      // delete eventData.playType

      setEventDetails(partData);
      // if (
      //   route.params.eventData.sDate &&
      //   route.params.eventData.sDate != "" &&
      //   route.params.eventData.eDate &&
      //   route.params.eventData.eDate != "undefined"
      // ) {

      //   setSelectedDate(
      //     route.params.eventData.sDate

      //   );
      // }
      if (savedEventData) {
        setEventData(savedEventData); // Set the event data

        // Process and format the date
        const formattedDate = savedEventData?.startDateTime
          ? dayjs(savedEventData?.startDateTime).format("DD/MM/YYYY HH:mm")
          : ""; // Fallback to sDate if startDateTime is not present

        setSelectedDate(formattedDate); // Update selectedDate
      }
    }
  }, []);

  const handleBackButton = () => {
    const localData = localStorage.getItem("createEventData");
    if (localData === null) {
      navigateToScreen(navigation, AppScreens.DrawerRoute);
    }
  };

  window.addEventListener("popstate", handleBackButton);

  async function getLoginUserData() {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);
      setAccessToken(data.AccessToken);
    }
  }

  async function updateProfile(newPlayGame, newOrganised) {
    const bodyParams = {
      accessToken: accessToken,
    };
    const response = await fetch(base_url + endpoints.auth.userProfile, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        body: bodyParams,
      }),
    });
    const profileData = await response.json();
    if (response.status !== 200) {
      console.error("Failed to fetch user profile data:", profileData.error);
      toast.error("Failed to fetch user profile data");
      return;
    }
    const playedGames = profileData.body?.playedGames || [];
    const organised = profileData.body?.organised || [];
    const updatedPlayGames = [...playedGames, newPlayGame];
    const updatedOrganised = [...organised, newOrganised];
    const params = {
      username: userData.username,
      accessToken: accessToken,
      organised: updatedOrganised,
    };
    fetch(base_url + endpoints.auth.updateProfile, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        body: params,
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.statusCode === 200) {
          toast.success("User profile updated successfully");
        } else {
          toast.error(json.body.error);
        }
      })
      .catch((error) => {
        console.error("Update profile API Error:- ", error);
      });
  }

  const callCreateEventAPI = async () => {
    setCreateShowLoader(true);
    let updatedEventDetails;
    if (
      savedEventData?.eventImageUrl?.fileName &&
      savedEventData?.eventImageUrl?.fileContent
    ) {
      const url = await callUploadToS3API(
        savedEventData?.eventImageUrl?.fileName,
        savedEventData?.eventImageUrl?.fileContent
      );
      updatedEventDetails = {
        ...eventDetails,
        eventImageUrl: url,
      };
    } else {
      updatedEventDetails = {
        ...eventDetails,
      };
    }

    const bodyParams = {
      accessToken: accessToken,
      eventDetails: updatedEventDetails,
    };

    try {
      const response = await createEvent(bodyParams);

      setCreateShowLoader(false);

      if (response.statusCode === 200 || response.statusCode === 201) {
        if (response.body) {
          if (response.body.eventID) {
            setEventId(response.body.eventID);

            const newPlayGame = {
              eventId: response.body.eventID,
              gameTitle: eventData.gameTitle,
            };
            const newOrganised = {
              eventId: response.body.eventID,
              gameTitle: eventData.gameTitle,
            };

            updateProfile(newPlayGame, newOrganised);

            if (response.body.message) {
              toast.success(response.body.message);
              const data = {
                ChallengerID: eventData.organiserID,
                GameName: eventData.gameTitle,
                Type: "Internal",
                eventType: eventData.eventType,
                Message: "Good luck!",
                EventID: response.body.eventID,
                StakeType: eventData.stakeType,
                StakeAmount: eventData.stakeAmount,
                OrganiserID: eventData.organiserId,
                DateTime: eventData.startDateTime,
                title: eventData.title,
                device: eventData.device,
                gamerID: eventData.gamerId.organiser,
              };
              setChallengeDetails(data);
              setInviteOpponentModal(true);
              localStorage.removeItem("createEventData");
            }
          }
        }
      } else if (response.statusCode === 500) {
        toast.error(response.body.error);
      } else if (response.statusCode === 400) {
        toast.error(response.body.error);
      } else {
        handleApiError(response.statusCode, response.body?.error || "");
      }
    } catch (error) {
      setCreateShowLoader(false);
      console.log("Authorization failed: " + error);
      toast.error(error.message);
    }
  };
  const generateRandomString = (length = 6) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const charactersLength = characters.length;

    while (result.length < length) {
      const randomIndex = Math.floor(Math.random() * charactersLength);
      result += characters.charAt(randomIndex);
    }
    return result;
  };
  const callUploadToS3API = async (fileName, fileContent) => {
    const randomUsername = generateRandomString(6);
    const bodyParams = {
      bucketName: "squdifi-event-thumbnail",
      fileName: fileName,
      fileContent: fileContent,
      username: randomUsername,
    };

    try {
      const response = await uploadToS3(bodyParams);

      if (response.statusCode === 200 || response.statusCode === 201) {
        if (response.body) {
          const profilePicture = response.body.fileUrl;
          setEventPicUrl(profilePicture);
          toast.success(response.body.message);
          return profilePicture;
        }
      } else {
        handleApiError(response.statusCode, response.body?.error || "");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const selectedStakeBelt = eventData?.stakeType?.map((item) => `${item}, `);
  const selectedStakeBeltAmount = eventData?.stakeAmount?.map(
    (item) => `${item}, `
  );
  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <ScreenBGGradientView />
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />

      <View style={[styles.container]}>
        {/* Create Event */}
        <Text
          style={[
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? AppFontStyle.BOLD_ANYBODY_20
              : AppFontStyle.BOLD_ANYBODY_32,
            {
              fontWeight: 800,
            },
          ]}
        >
          Event summary
        </Text>

        <ScrollView
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{
            flexDirection:
              deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.SM ||
              deviceSize === DEVICE_SIZES.MD ||
              deviceSize === DEVICE_SIZES.LG
                ? "column"
                : "row",
            justifyContent: "space-between",
          }}
        >
          <View style={[styles.mainView]}>
            <View style={styles.divider} />
            {/* Details of the event */}
            <View style={styles.leftWrapper}>
              <View>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { marginBottom: 24 },
                  ]}
                >
                  Details of the event
                </Text>
                <View style={{ gap: 16 }}>
                  {/* Event Type */}
                  <View
                    style={[
                      styles.detailsWrapper,
                      // { marginTop: 30, },
                    ]}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        {
                          color: AppColors.gray_C3C3C3,
                        },
                      ]}
                    >
                      Event Type
                    </Text>
                    <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                      {/* {eventData != null ? eventData.type : ""} */}
                      {savedEventData?.eventType}
                    </Text>
                  </View>
                  {/* Event Name */}
                  <View style={styles.detailsWrapper}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        {
                          color: AppColors.gray_C3C3C3,
                        },
                      ]}
                    >
                      Event Name
                    </Text>
                    <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                      {eventData != null ? eventData?.title : ""}
                      {/* My event */}
                    </Text>
                  </View>
                  {/* Play Type */}
                  <View style={styles.detailsWrapper}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        {
                          color: AppColors.gray_C3C3C3,
                        },
                      ]}
                    >
                      Play Type
                    </Text>
                    <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                      {eventData != null ? eventData?.challengeMode : ""}
                    </Text>
                  </View>
                  {/* Game */}
                  <View style={styles.detailsWrapper}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        {
                          color: AppColors.gray_C3C3C3,
                        },
                      ]}
                    >
                      Game
                    </Text>
                    <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                      {eventData != null ? eventData?.gameTitle : ""}
                    </Text>
                  </View>
                  {/* Device */}
                  <View style={styles.detailsWrapper}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        {
                          color: AppColors.gray_C3C3C3,
                        },
                      ]}
                    >
                      Device
                    </Text>
                    <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                      {eventData?.device}
                    </Text>
                  </View>
                  {/* Gamer Id */}
                  <View style={styles.detailsWrapper}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        {
                          color: AppColors.gray_C3C3C3,
                        },
                      ]}
                    >
                      Gamer ID
                    </Text>
                    <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                      {eventData != null ? eventData?.gamerId?.organiser : ""}
                    </Text>
                  </View>{" "}
                </View>
              </View>

              {eventData != null &&
              eventData?.eventImageUrl?.fileContent != null &&
              eventData?.eventImageUrl?.fileContent != "" ? (
                <View>
                  <Image
                    source={{ uri: eventData?.eventImageUrl?.fileContent }}
                    style={{
                      height:
                        deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                          ? 186
                          : 150,
                      width:
                        deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                          ? 188
                          : 250,
                      alignSelf: "center",
                      resizeMode: "contain",
                      marginTop:
                        deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 0 : 20,
                    }}
                  />
                </View>
              ) : (
                <View>
                  <Image
                    source={{
                      uri: AppImages.Placeholder,
                    }}
                    style={{
                      height:
                        deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                          ? 186
                          : 150,
                      width:
                        deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                          ? 188
                          : 250,
                      alignSelf: "center",
                      resizeMode: "contain",
                    }}
                  />
                </View>
              )}

              {/* Event date Time */}
              <View>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { marginBottom: 24 },
                  ]}
                >
                  Event date and time
                </Text>
                <View
                  style={[
                    styles.detailsWrapper,
                    // { marginTop: 30, },
                  ]}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      {
                        color: AppColors.gray_C3C3C3,
                      },
                    ]}
                  >
                    Date and time
                  </Text>
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                    12/12/2024 12:00-14:00
                  </Text>
                </View>
              </View>
            </View>
            <View style={styles.descriptionWrapper}>
              {/* Description */}
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  { color: AppColors.white },
                ]}
              >
                Description
              </Text>

              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  { color: AppColors.white },
                ]}
              >
                {eventData != null ? eventData?.description : ""}
                {/* Get ready for a gaming event like no other! Join us
                            for "Brick Battle Royale: LEGO Fortnite Showdown," a
                            spectacular streaming event that combines the
                            creativity of LEGO with the excitement of Fortnite
                            in an epic showdown of miniature proportions.
                            {"\n\n"}🎮 Game Mode: We're bringing the world of
                            Fortnite to life using LEGO bricks! Our talented
                            builders have meticulously recreated iconic Fortnite
                            landscapes, weapons, and characters using LEGO, and
                            now it's time to put them to the test. Watch as
                            players engage in thrilling battles and intense
                            building battles on our custom-made LEGO Fortnite
                            battlegrounds. */}
              </Text>
            </View>
            <View style={styles.divider} />

            <View style={{ gap: 12, marginTop: 20 }}>
              <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                Opponents
              </Text>
              <View>
                <ScrollView
                  horizontal={true}
                  showsHorizontalScrollIndicator={
                    deviceSize === DEVICE_SIZES.XL ? true : false
                  }
                  style={{
                    width: screenWidth - 32,
                  }}
                  contentContainerStyle={{
                    flexDirection: "row",
                    gap: 12,
                  }}
                >
                  {[1, 2, 3, 4].map((item, index) => (
                    <View
                      style={{
                        gap: 12,
                        alignItems: "center",
                      }}
                      key={index}
                    >
                      <View
                        style={{
                          height: 40,
                          width: 40,
                          backgroundColor: AppColors.white,
                          borderRadius: 40,
                          overflow: "hidden",
                        }}
                      >
                        <View
                          style={{
                            width: 82,
                            height: 40,
                          }}
                        >
                          <CropImage
                            image={
                              "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                            }
                            clipId="clip-head"
                            x={30}
                            y={0}
                            width={95}
                            height={85}
                            scale={2.3}
                            transform={"translate(-33, 0)"}
                          />
                        </View>
                      </View>
                      <Text
                        style={[
                          AppFontStyle.MEDIUM_ANYBODY_12,
                          { color: AppColors.white, textAlign: "center" },
                        ]}
                      >
                        Isabella
                      </Text>
                    </View>
                  ))}
                </ScrollView>
              </View>
            </View>

            <View style={styles.divider} />
            <View>
              <ScrollView
                horizontal={true}
                showsHorizontalScrollIndicator={false}
                style={{
                  width: screenWidth - 32, // Match the parent width with some padding
                  marginTop: 20,
                }}
                contentContainerStyle={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: 10,
                  paddingHorizontal: 8, // Add padding for better spacing
                }}
              >
                <View style={{ gap: 8 }}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      {
                        color: AppColors.gray_C4C4C4,
                        textAlign: "center",
                      },
                    ]}
                  >
                    Duration
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { textAlign: "center" },
                    ]}
                  >
                    1 hour
                  </Text>
                </View>
                <View style={{ gap: 8 }}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      {
                        color: AppColors.gray_C4C4C4,
                        textAlign: "center",
                      },
                    ]}
                  >
                    Quality
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { textAlign: "center" },
                    ]}
                  >
                    High (1080p & 60fps)
                  </Text>
                </View>
                <View style={{ gap: 8 }}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      {
                        color: AppColors.gray_C4C4C4,
                        textAlign: "center",
                      },
                    ]}
                  >
                    Ticket Price
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { textAlign: "center" },
                    ]}
                  >
                    $23 - 34 tokens
                  </Text>
                </View>
                <View style={{ gap: 8 }}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      {
                        color: AppColors.gray_C4C4C4,
                        textAlign: "center",
                      },
                    ]}
                  >
                    Min Number of Attendees
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { textAlign: "center" },
                    ]}
                  >
                    100
                  </Text>
                </View>{" "}
                <View style={{ gap: 8 }}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      {
                        color: AppColors.gray_C4C4C4,
                        textAlign: "center",
                      },
                    ]}
                  >
                    Max Number of Attendees
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { textAlign: "center" },
                    ]}
                  >
                    1000
                  </Text>
                </View>
                <View style={{ gap: 8 }}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      {
                        color: AppColors.gray_C4C4C4,
                        textAlign: "center",
                      },
                    ]}
                  >
                    Time limit
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { textAlign: "center" },
                    ]}
                  >
                    Week
                  </Text>
                </View>{" "}
                <View style={{ gap: 8 }}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      {
                        color: AppColors.gray_C4C4C4,
                        textAlign: "center",
                      },
                    ]}
                  >
                    Kaller Revenue
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { textAlign: "center" },
                    ]}
                  >
                    30%
                  </Text>
                </View>{" "}
                <View style={{ gap: 8 }}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      {
                        color: AppColors.gray_C4C4C4,
                        textAlign: "center",
                      },
                    ]}
                  >
                    Challenger Revenue
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      { textAlign: "center" },
                    ]}
                  >
                    30%
                  </Text>
                </View>
              </ScrollView>
            </View>
            <View style={styles.divider} />

            <View style={styles.leftWrapper}>
              <View style={{ gap: 12 }}>
                <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                  Selected Stakes for the event
                </Text>
                <View>
                  <ScrollView
                    horizontal={true}
                    showsHorizontalScrollIndicator={
                      deviceSize === DEVICE_SIZES.XL ? true : false
                    }
                    style={{
                      width: screenWidth - 32,
                    }}
                    contentContainerStyle={{
                      flexDirection: "row",
                      gap: 12,
                    }}
                  >
                    {[1, 2, 3, 4, 5].map((item, index) => (
                      <View style={{ gap: 12 }} key={index}>
                        <Image
                          source={AppImages.icBronzeBelt}
                          style={{
                            height: 54,
                            width: 70,
                          }}
                        />
                        <Text
                          style={[
                            AppFontStyle.MEDIUM_ANYBODY_12,
                            { textAlign: "center" },
                          ]}
                        >
                          1
                        </Text>
                      </View>
                    ))}
                  </ScrollView>
                </View>
              </View>
            </View>
            <View style={styles.divider} />

            <View style={{ flex: 1, gap: 12, marginTop: 20 }}>
              <Text style={[AppFontStyle.REGULAR_ANYBODY_16, {}]}>
                Terms & condition
              </Text>
              <View style={{ flexDirection: "row", gap: 12 }}>
                <TouchableOpacity
                  onPress={toggleCheckbox}
                  style={styles.checkbox}
                >
                  {isChecked && (
                    <Icon
                      name="check"
                      size={18}
                      color={AppColors.white}
                      style={styles.checkmark}
                    />
                  )}
                </TouchableOpacity>
                <View
                  style={{
                    gap: 24,
                    width:
                      deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? "80%"
                        : "95%",
                  }}
                >
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_16, {}]}>
                    By confirming, you agree to the following terms:
                  </Text>
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_16, {}]}>
                    The total cost of the event, including streaming fees, will
                    be deducted from your token balance and held securely until
                    the event goes live. Once the event is listed for the
                    audience, no refunds will be issued unless the minimum
                    attendee requirement is not met. If the minimum number of
                    attendees is not reached by the deadline, the streaming cost
                    will be refunded, and the event can be cancelled or can go
                    live on the agreement of both parties.
                  </Text>
                </View>
              </View>
            </View>
          </View>
          <View
            style={{
              width:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "100%"
                  : deviceSize === DEVICE_SIZES.MD ||
                    deviceSize === DEVICE_SIZES.LG
                  ? "49%"
                  : "18%",
              gap: 23,
              marginTop:
                deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ||
                deviceSize === DEVICE_SIZES.MD ||
                deviceSize === DEVICE_SIZES.LG
                  ? 12
                  : 30,
            }}
          >
            <TicketDetail />
            <View
              style={{
                borderRadius: 24,
                borderColor: AppColors.gray_A6A3AA,
                backgroundColor: AppColors.purple_453B50,
                borderWidth: 1,
                padding: 24,
                gap: 12,
              }}
            >
              <Text
                style={[AppFontStyle.MEDIUM_ANYBODY_18, { lineHeight: 20 }]}
              >
                Ticket refund policy
              </Text>
              <Text
                style={[
                  AppFontStyle.MEDIUM_ANYBODY_18,
                  { color: AppColors.gray_C4C4C4, lineHeight: 20 },
                ]}
              >
                If the minimum attendees are not met within the timeframe, the
                organiser & challenger are notified:
              </Text>
              <Text
                style={[
                  AppFontStyle.MEDIUM_ANYBODY_18,
                  { color: AppColors.gray_C4C4C4, lineHeight: 20 },
                ]}
              >
                ✅ They can choose to proceed anyway. ❌ If either player
                declines, the event is cancelled, and all ticket purchasers are
                refunded.
              </Text>
            </View>
          </View>
        </ScrollView>
        <View
          style={{
            width:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "100%"
                : "80%",
          }}
        >
          <View style={styles.divider} />
          {/* Next Button */}
          <View
            style={{
              justifyContent: "flex-end",
              flexDirection: "row",
              marginTop: 40,
              gap: 10,
            }}
          >
            <Text
              style={{
                position: "absolute",
                top: -30,
                // left: "80%",
                right: 0,
                textAlign: "center",
                color: AppColors.white,
                fontSize: 13,
              }}
            >
              Note: You cannot change the Stakes
            </Text>

            <TouchableOpacity
              style={{
                borderRadius: 10,
                justifyContent: "center",
                alignItems: "center",
                borderWidth: 2,
                borderColor: AppColors.appViolentColor_6D08C3,
              }}
              onPress={() => {
                navigateToScreen(
                  navigation,
                  AppScreens.CreatePublicEventScreen,
                  {
                    eventType: "Public",
                  }
                );
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  {
                    paddingVertical: 12,
                    paddingHorizontal: 40,
                    color: AppColors.white,
                  },
                ]}
              >
                Edit
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                backgroundColor: AppColors.appViolentColor_6D08C3,
                borderRadius: 10,
                justifyContent: "center",
                alignItems: "center",
              }}
              onPress={() => {
                // const data = {
                //     challengerID: eventData.organiserID,
                //     gameName: eventData.gameTitle,
                //     type: "Internal",
                //     message: "Good luck!",
                //     eventID: "sdsdsf",
                // };
                // setChallengeDetails(data);
                // setInviteOpponentModal(true);

                callCreateEventAPI();
                fetchStatus();
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  {
                    paddingVertical: 8,
                    paddingHorizontal: 40,
                    color: AppColors.white,
                  },
                ]}
              >
                Confirm and invite opponent
              </Text>
            </TouchableOpacity>
          </View>
        </View>
        {inviteOpponentModal && (
          <InviteOpponentModal
            showModal={inviteOpponentModal}
            setShowModal={setInviteOpponentModal}
            challengeDetails={challengeDetails}
            selectedOption={(options) => {
              setInviteOpponentModal(false);
              if (options === "Friends") {
                challengeDetails.type = "Internal";
                setChallengeDetails(challengeDetails);
                setSearchFromFriendsModal(true);
              } else {
                challengeDetails.type = "External";
                setChallengeDetails(challengeDetails);
                setInviteSocialMediaModal(true);
              }
            }}
            onClose={() => {
              navigateToScreen(navigation, AppScreens.OnGoingEvents, {
                eventID: eventID,
              });
            }}
          />
        )}
        {searchFromFriendsModal && (
          <SearchFromFriendsModal
            accessToken={accessToken}
            challengeDetails={challengeDetails}
            showModal={searchFromFriendsModal}
            setShowModal={setSearchFromFriendsModal}
            successCallback={() => {
              setShowSuccessModal(true);
            }}
            backTapped={() => {
              setInviteOpponentModal(true);
            }}
            onClose={() => {
              setInviteOpponentModal(true);
            }}
          />
        )}
        {inviteSocialMediaModal && (
          <InviteSocialMediaModal
            accessToken={accessToken}
            challengeDetails={challengeDetails}
            showModal={inviteSocialMediaModal}
            setShowModal={setInviteSocialMediaModal}
            eventDetails={eventDetails}
            eventType={eventType}
            eventID={eventID}
            status={eventDetails?.status}
            platformStatus={platformStatus}
            backTapped={() => {
              setInviteOpponentModal(true);
            }}
            onClose={() => {
              setInviteOpponentModal(true);
            }}
          />
        )}
        {showCreateLoader && <ShowLoader showIndicater={showCreateLoader} />}
        {showSuccessModal && (
          <ChallengeSentSuccessfulyModal
            eventID={eventID}
            showModal={showSuccessModal}
            eventDetails={eventDetails}
            setShowModal={setShowSuccessModal}
            platformStatus={platformStatus}
            onClose={() => {
              navigateToScreen(navigation, AppScreens.OnGoingEvents, {
                eventID: eventID,
              });
            }}
          />
        )}
      </View>
    </View>
  );

  function TitleValueText({ title, value }) {
    return (
      <View style={[styles.detailsWrapper]}>
        <Text
          style={[
            AppFontStyle.REGULAR_ANYBODY_14,
            { color: AppColors.gray_C3C3C3 },
          ]}
        >
          {title}
        </Text>
        <Text
          style={[
            AppFontStyle.REGULAR_ANYBODY_14,
            { color: AppColors.gray_C3C3C3 },
          ]}
        >
          {value}
        </Text>
      </View>
    );
  }
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      padding: 30,
    },
    mainView: {
      // flex: 1,
      width: "80%",
      // paddingHorizontal: 40,
    },
    divider: {
      height: 2,
      marginTop: 16,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: "100%",
    },
    detailsWrapper: {
      flexDirection: "row",
      justifyContent: "space-between",

      gap: 10,
      flex: 1,
    },
    leftWrapper: {
      flexDirection: "row",
      width: "60%",
      marginTop: 20,
      gap: 30,
    },
    descriptionWrapper: {
      flexDirection: "column",
      marginTop: 35,
      width: "60%",
      gap: 16,
    },
    checkbox: {
      width: 24,
      height: 24,
      borderWidth: 2,
      borderColor: AppColors.white,
      backgroundColor: "transparent",
      justifyContent: "center",
      alignItems: "center",
    },
    checkmark: {
      // Adjust position if needed
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        padding: 30,
      },
      mainView: {
        // flex: 1,
        // paddingHorizontal: 40,
        // marginHorizontal: 30,
      },
      divider: {
        height: 2,
        marginTop: 16,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      detailsWrapper: {
        flexDirection: "row",
        justifyContent: "space-between",

        gap: 10,
        flex: 1,
      },
      leftWrapper: {
        flexDirection: "row",
        width: "80%",
        marginTop: 20,
        gap: 16,
      },
      descriptionWrapper: {
        flexDirection: "column",
        marginTop: 35,
        width: "90%",
        gap: 16,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        padding: 15,
      },
      mainView: {
        // flex: 1,
        // paddingHorizontal: 25,
        // marginHorizontal: 16,
      },
      divider: {
        height: 2,
        marginTop: 16,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      detailsWrapper: {
        flexDirection: "row",
        justifyContent: "space-between",

        gap: 10,
        flex: 1,
      },
      leftWrapper: {
        flexDirection: "row",
        width: "90%",
        marginTop: 20,
        gap: 16,
      },
      descriptionWrapper: {
        flexDirection: "column",
        marginTop: 35,
        width: "95%",
        gap: 16,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        padding: 15,
      },
      mainView: {
        // flex: 1,
        width: "auto",
        // paddingHorizontal: 16,
        // marginHorizontal: 15,
      },
      divider: {
        height: 2,
        marginTop: 16,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      detailsWrapper: {
        flexDirection: "row",
        justifyContent: "space-between",

        gap: 10,
        flex: 1,
      },
      leftWrapper: {
        flexDirection: "row",
        width: "90%",
        marginTop: 20,
        gap: 16,
      },
      descriptionWrapper: {
        flexDirection: "column",
        marginTop: 35,
        width: "95%",
        gap: 16,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        padding: 15,
      },
      mainView: {
        // flex: 1,
        width: "auto",
        // marginHorizontal: 15,
      },
      divider: {
        height: 2,
        marginTop: 16,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      detailsWrapper: {
        flexDirection: "row",
        justifyContent: "space-between",

        gap: 10,
        // flex: 1,
      },
      leftWrapper: {
        flexDirection: "column",
        width: "100%",
        marginTop: 20,
        gap: 10,
      },
      descriptionWrapper: {
        flexDirection: "column",
        marginTop: 35,
        width: "100%",
        gap: 16,
      },
    },
  }
);
